// extracted by mini-css-extract-plugin
export default {"wrap":"hr-z","logoContainer":"ir-z","brandImg":"jr-z","logoImg":"kr-z","logoButton":"lr-z"};